import httpService from "..";

export const getDocumentsApi = async (groupId: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document?groupId=${groupId}`,
    "get"
  );
};

export const getDocumentApi = async (id: string, type: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document/${id}?type=${type}`,
    "get"
  );
};

export const addGroupDocumentApi = async (groupId: any, data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document/group?groupId=${groupId}`,
    "post",
    data
  );
};

export const addCommunicationDocumentApi = async (groupId: any, data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document/communication?groupId=${groupId}`,
    "post",
    data
  );
};

export const addMemberDocumentApi = async (memberId: any, data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document/member?memberId=${memberId}`,
    "post",
    data
  );
};

export const addImageApi = async (data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document/image`,
    "post",
    data
  );
};

export const downloadDocumentApi = async (data: { Link: string } | string) => {
  const body =
    typeof data === "string"
      ? { Link: data }
      : { Link: data?.Link };

  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document/download-document`,
    "post",
    body
  );
};

export const generateDocumentApi = async (
  id: string,
  type: string,
  memberId: any
) => {
  if (!id) {
    throw new Error("Document ID is required to generate a document.");
  }
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document/generate-document/${id}?type=${type}&memberId=${memberId}`,
    "post",
    {}
  );
};

export const generateBulkDocumentApi = async (
  id: string,
  type: string,
  groupId: any
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document/generate-group-documents/${id}?type=${type}&groupId=${groupId}`,
    "post",
    {}
  );
};

export const sendDocumentApi = async (
  memberId: any,
  data: any,
  userId: any
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document/send-document?memberId=${memberId}&userId=${userId}`,
    "post",
    data
  );
};

export const sendDigitalDocumentApi = async (id: string, memberId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document/send-digital-document/${id}?memberId=${memberId}`,
    "post",
    {}
  );
};

export const editDocumentApi = async (id: string, type: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document/${id}?type=${type}`,
    "patch",
    data
  );
};

export const removeDocumentApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document/${id}`,
    "delete"
  );
};

export const removeMemberDocumentApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/document/member/${id}`,
    "delete"
  );
};
